import React from 'react';
import { FrameType, IImageData } from './types';
import { ContainerImages, ImageItem } from './styled';
import { decideFrameType } from './utils';
import SliderNavigation from './SliderNavigation';
import ImagesCounter from './ImagesCounter';
import SliderFooter from './SliderFooter';

interface MultipleImageProps {
  images: Array<IImageData>;
  active: number;
  frameType: FrameType;
  isSinglePost: boolean;
  setActive: (val: any) => void;
  onClick: () => void;
}

export default function MultipleImage({
  images,
  active,
  frameType,
  isSinglePost,
  setActive,
  onClick,
}: MultipleImageProps) {
  const hasNextButton = active < images.length - 1;
  const hasPrevButton = active > 0;

  const handleNext = () => {
    setActive(active + 1);
  };

  const handlePrev = () => {
    setActive(active - 1);
  };

  const imageFrameType = frameType !== 'FRAME_TYPE_UNSPECIFIED'
    ? frameType
    : decideFrameType(images);

  const generateCustomStyle = (image: IImageData) => {
    const style: React.CSSProperties = {};
    if (image.frame_type === 'FRAME_TYPE_LANDSCAPE') {
      if (image.ratio < 1.78 && imageFrameType === 'FRAME_TYPE_LANDSCAPE') {
        style.width = 'max-content';
        style.height = '100%';
      }
    }

    if (image.frame_type === 'FRAME_TYPE_PORTRAIT') {
      style.width = 'auto';

      if (image.ratio <= 0.8) {
        style.height = '100%';
      }

      if (image.ratio > 0.8) {
        style.width = '100%';
      }
    }

    if (image.frame_type === 'FRAME_TYPE_SQUARE') {
      if (image.ratio < 1 && imageFrameType === 'FRAME_TYPE_SQUARE') {
        style.width = 'max-content';
        style.height = '100%';
      }
    }

    // unspecified, ratio = 0
    if (image.frame_type === 'FRAME_TYPE_UNSPECIFIED') {
      style.width = 'max-content';
      style.height = '100%';
    }

    if (isSinglePost) {
      style.maxHeight = 'auto';
    }

    return style;
  };

  return (
    <>
      <ContainerImages frameType={imageFrameType} onClick={onClick}>
        <ImagesCounter current={active} total={images.length} />
        <SliderNavigation type="prev" visible={hasPrevButton} onClick={handlePrev} />
        {images.map((image, i) => (
          <ImageItem
            visible={active === i}
            src={image.image}
            alt="tes"
            imageFrameType={image.frame_type}
            frameType={imageFrameType}
            ratio={image?.ratio}
            onClick={onClick}
            style={generateCustomStyle(image)}
          />
        ))}
        <SliderNavigation type="next" visible={hasNextButton} onClick={handleNext} />
      </ContainerImages>
      <SliderFooter current={active} total={images.length} onClick={setActive} />
    </>
  );
}
